import './App.css';
import CountdownTimer from './CountdownTimer';

function App() {
  // Hedef tarihi buradan değiştirebilirsiniz
  const targetDate = new Date('2026-01-01T00:00:00');

  return (
    <div className="container">
      <img src={process.env.PUBLIC_URL + '/logo_ertago.jpg'} alt="Ertago Logo" className="logo" />
      <h1 className="coming-soon">Çok Yakında</h1>
      <CountdownTimer targetDate={targetDate} />
    </div>
  );
}

export default App;
